<div class="popup-backdrop"></div>
<div class="profile_data">

  <!-- If no profile pic and not in edit/camera -->
  <div class="popup-container" *ngIf="(!profileData?.blobImageUrl && !(showCamera || changedProfile || isFrmOpenFile))">
    <button class="close-button" title="cancel" (click)="closePopup()">×</button>
    <div class="popup-header">
      <h3>Profile picture</h3>
    </div>
    <p class="header-text">Make your pharmacy app experience more personal and recognizable.</p>
    <div class="backgrnd_clr_img">
      <div *ngIf="errorMessage" class="error-message">{{ errorMessage }}</div>
      <div class="profile-picture">
        <img [src]="tempProfileImage" alt="Profile" class="profileImg"/>
      </div>
      <div class="popup-actions">
        <button class="change-button" (click)="triggerFileUpload()">
          <span class="material-symbols-outlined">add_photo_alternate</span>
          <span class="text_change">Upload picture</span>
        </button>
        <button class="change-button" (click)="openCamera('user')">
          <span class="material-symbols-outlined">photo_camera</span>
          <span class="text_change">Take picture</span>
        </button>
      </div>
    </div>
  </div>

  <!-- Edit/crop/capture step -->
  <div class="popup-container" *ngIf="isFrmOpenFile">
    <button class="close-button" title="cancel" (click)="closePopup()">×</button>
    <div class="capture-popup-header">
      <span class="arrow_back">
        <span class="material-symbols-outlined" (click)="moveToPreviousPopup()">arrow_back</span>
      </span>
      <h3>New profile picture</h3>
    </div>
    <p class="new_header-text">Make your profile picture perfect by cropping and rotating it.</p>
    <div class="cap_backgrnd_clr_img">
      <div class="rotate_icon">
        <button class="rotate_button" (click)="rotateImage()">
          <span class="material-symbols-outlined">rotate_90_degrees_ccw</span><br>Rotate
        </button>
      </div>
      <div class="new-profile-picture">
        <image-cropper *ngIf="!isFrmCapture"
          [imageChangedEvent]="imageChangedEvent"
          [maintainAspectRatio]="true"
          [aspectRatio]="1/1"
          [resizeToWidth]="800"
          format="png"
          (imageCropped)="imageCropped($event)"
          (imageLoaded)="imageLoaded($event)"
          [cropperStyle]="cropperStyle"
        ></image-cropper>
        <img *ngIf="isFrmCapture" [src]="tempProfileImage" alt="Profile" class="profileImg"/>
      </div>
      <div class="new-popup-actions">
        <button class="change-button" (click)="saveProfile()"><span class="text_change">Save Profile Picture</span></button>
        <button class="change-button" (click)="closePopup()"><span class="text_change">Cancel</span></button>
      </div>
    </div>
  </div>

  <!-- Camera step -->
  <div class="popup-container" *ngIf="showCamera">
    <button class="close-button" title="cancel" (click)="closePopup('camera')">×</button>
    <div class="capture-popup-header">
      <span class="arrow_back">
        <span class="material-symbols-outlined" (click)="moveToPreviousPopup()">arrow_back</span>
      </span>
      <h3>Take picture</h3>
    </div>
    <p class="header-text">Make your pharmacy app experience more personal and recognizable.</p>
    <div class="cap_backgrnd_clr_img">
      <div></div>
      <video class="video_capture" *ngIf="showCamera" #videoElement autoplay muted playsinline></video>
      <div *ngIf="showCamera" class="capture-actions">
        <button class="capture-button" (click)="captureImage()">
          <span class="material-symbols-outlined">photo_camera</span>
          <span class="text_change">Capture</span>
        </button>
        <button class="capture-button" (click)="flipCamera()">
          <span class="material-symbols-outlined">flip_camera_android</span>
          <span class="text_change">Flip</span>
        </button>
      </div>
    </div>
  </div>

  <!-- If profile picture exists (default view) -->
  <div class="popup-container" *ngIf="profileData?.blobImageUrl && ((!isFrmOpenFile && !showCamera && !changedProfile) || isFrmChanged)">
    <button class="close-button" title="cancel" (click)="closePopup('change')">×</button>
    <div class="popup-header">
      <h3>Profile picture</h3>
    </div>
    <p class="header-text header_change">Make your pharmacy app experience more personal and recognizable.</p>
    <div class="backgrnd_clr_img">
      <div class="profile-picture">
        <img [src]="tempProfileImage" alt="Profile" class="profileImg"/>
      </div>
      <div class="popup-actions">
        <button class="change-button" (click)="changeProfile()">
          <span class="material-symbols-outlined">edit</span>
          <span class="text_change">Change</span>
        </button>
        <button class="change-button" (click)="removeProfile()">
          <span class="material-symbols-outlined">delete</span>
          <span class="text_change">Remove</span>
        </button>
      </div>
    </div>
  </div>

  <!-- After clicking Change -->
  <div class="popup-container" *ngIf="changedProfile && !isFrmOpenFile && !showCamera">
    <button class="close-button" title="cancel" (click)="closePopup('change')">×</button>
    <div class="capture-popup-header">
      <span class="arrow_back">
        <span class="material-symbols-outlined" (click)="moveToPreviousPopup('changed')">arrow_back</span>
      </span>
      <h3>Change Profile picture</h3>
    </div>
    <p class="header-text">Make your pharmacy app experience more personal and recognizable.</p>
    <div class="backgrnd_clr_img">
      <div *ngIf="errorMessage" class="error-message">{{ errorMessage }}</div>
      <div class="profile-picture">
        <img [src]="tempProfileImage" alt="Profile" class="profileImg"/>
      </div>
      <div class="popup-actions">
        <button class="change-button" (click)="triggerFileUpload()">
          <span class="material-symbols-outlined">add_photo_alternate</span>
          <span class="text_change">Upload picture</span>
        </button>
        <button class="change-button" (click)="openCamera('user')">
          <span class="material-symbols-outlined">photo_camera</span>
          <span class="text_change">Take picture</span>
        </button>
      </div>
    </div>
  </div>

  <div class="upload-section">
    <input type="file" #fileInput accept="image/*" (change)="onFileSelected($event)" style="display: none;" />
  </div>
</div>
